/* eslint-disable react/jsx-key */
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { Button } from '@cian/ui-kit/button';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './TourComponent.css';

export interface ITourComponentProps {
  children?: React.ReactNode;
  noFullscreen?: boolean;
  onShow: () => void;
  onClick: () => void;
}

export const TourComponent = ({ children, onShow, onClick, noFullscreen }: ITourComponentProps) => {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    onClick();
    setOpen(true);
  };

  useIsomorphicLayoutEffect(onShow, []);

  return (
    <div className={styles['tour']} id={'tourBlock'}>
      <h2 className={styles['title']}>3D-тур по квартире</h2>
      <div className={styles['content']}>
        {open ? (
          children
        ) : (
          <div className={styles['layout']} data-tour={'layout'} onClick={handleClick}>
            <div className={styles['text']}>
              <InlineText1 userSelect="none" color="white_100">
                Совершите виртуальный тур по квартире, посмотрите на вид из окна и узнайте, где будет солнце в течение
                дня
              </InlineText1>
            </div>
            <Button theme="fill_white_primary" size="XS">
              Смотреть планировку в 3D
            </Button>
            <div className={styles['navigation']}>
              <div className={styles['navigation-left']}>
                <div className={styles['navigation-walk']} role="img"></div>
                <div className={styles['navigation-orbit']} role="img"></div>
              </div>
              <div className={styles['navigation-right']}>
                <div className={styles['navigation-time']}>
                  <div className={styles['navigation-arrow-left']} role="img"></div>
                  <div className={styles['navigation-num']} role="img"></div>
                  <div className={styles['navigation-arrow-right']} role="img"></div>
                </div>
                <div className={styles['navigation-photo']} role="img"></div>
                <div className={styles['navigation-info']} role="img"></div>
                {!noFullscreen && <div className={styles['navigation-area']} role="img"></div>}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

TourComponent.displayName = 'TourComponent';
